export default "/images/box.svg?6f10ebcd04d27bfea8c76cf2445fec6f";